import { Controller } from "react-hook-form";
import React from "react";
import { CustomSelect } from "assets/kits/inputs/Input.tsx";

export const arrayToSelectOptions = (array) => {
  return array.map((it) => ({ ...it, value: it.id, label: it.txt }));
};

const OptionsProduct = ({ formControl, options, setOptions }) => {
  const updatedOption = (item, key, value) => {
    setOptions(
      options.map((it) => {
        if (it.options_id != item.options_id) return it;
        return {
          ...it,
          [key]: value,
        };
      })
    );
  };

  return (
    <div className="w-100 pd-t-12 font-14-500">
      <div className="d-flex w-100 font-12-600 border-bottom text-secondary justify-content-between mr-b-8 pd-b-10 mr-b-12 pd-x-16">
        <span>ویژگی</span>
        <span>مقادیر</span>
        <span>متاثر در قیمت</span>
      </div>

      {options.length > 0 ? (
        options.map((item) => (
          <div className="d-flex flex-row align-items-center card border-2 border-opacity-25 shadow-sm pd-y-8 pd-x-16 mr-b-8">
            <span className="wd-100 text-break pd-x-0 text-center">
              {item.title}
            </span>

            <div className="col pd-x-0 border-start">
              <CustomSelect
                containerClassName=" shadow-none bg border-0 sm-medium rd-8 pd-l-16 pd-r-8 lgn-bold"
                className="lgn-medium"
                placeholder="انتخاب کنید"
                isMulti={true}
                value={item.selectedFeaturs}
                options={arrayToSelectOptions(item.features)}
                onChange={(options) =>
                  updatedOption(
                    item,
                    "selectedFeaturs",
                    options.map((op) => ({ ...op, title: item.title }))
                  )
                }
                labelClassName="p-0 m-0"
                inputHeight={40}
              />
            </div>

            <div className="pd-x-8 d-flex justify-content-center">
              <input
                type="checkbox"
                checked={item.isChangedPrice}
                onChange={() =>
                  updatedOption(item, "isChangedPrice", !item.isChangedPrice)
                }
                className="form-check-input shadow-none wh-20 rd-4"
              />
            </div>
          </div>
        ))
      ) : (
        <div className="d-flex justify-content-center pd-t-12 text-secondary text-opacity-75">
          <span>« هیچ ویژگی وجود ندارد »</span>
        </div>
      )}
    </div>
  );
};

export default OptionsProduct;
